export default "__VITE_ASSET__Cp5aZHa5__"